import React from 'react';

import HeaderApp from 'components/Header/HeaderApp';
import Bottom from 'components/Bottom';
import ContentResumoPedido from './ContentResumoPedido';

const App = () => {
  return (
    <div className="d-flex flex-column min-h-screen">
      <HeaderApp />
      <ContentResumoPedido />
      <Bottom />
    </div>
  );
};

export default App;
